import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding: 24px;
  gap: 5px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.07);
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-left: auto;
`;

const buttonBase = `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 10px 16px;
  border: 1px solid #11a7d9;
  border-radius: 10px;
  box-shadow: 0px 0.751px 1.503px 0px rgba(16, 24, 40, 0.05);
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-decoration: none;
  cursor: pointer;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #40a9ff;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const OutlineButton = styled.button`
  ${buttonBase}
  background: #fff;
  color: #11a7d9;

  &:hover,
  &:focus {
    color: #11a7d9;
  }
`;

export const ViewButton = styled.button`
  ${buttonBase}
  background: #11a7d9;
  color: #fff;

  &:hover,
  &:focus {
    color: #fff;
  }

  /* A tabela de produtos posiciona "td svg" em absoluto para o icone de expandir. */
  && svg {
    position: static;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px 16px;
  text-align: center;
`;

export const EmptyIcon = styled.div`
  color: #b5b7c4;
`;

export const EmptyMessage = styled.span`
  max-width: 520px;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6c6c6c;
`;
